import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

import { isGroupcalApp } from './appType'
import { isInIframe } from './env'

export function isUserLoggedIn() {
  return !!LocalStorage.get(LocalStorageKey.USER_ID)
}

export function isGuest() {
  return (
    isGroupcalApp() &&
    ((!LocalStorage.get(LocalStorageKey.PHONE_NUMBER) &&
      window.location.pathname.includes('/calendar')) ||
      isInIframe())
  )
}
